import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './styles.css';

class WindowOptionButton extends Component {
	render() {
		const {
			onClick,
			backgroundColor,
			color,
			textOnOver,
			className
		} = this.props;
		return (
			<div
				onClick={() => onClick()}
				style={{ backgroundColor, color }}
				className={`${className || ''} window-option-button`}
			>
				<span className="window-option-button-text">{textOnOver}</span>
			</div>
		);
	}
}
WindowOptionButton.propTypes = {
	onClick: PropTypes.func,
	backgroundColor: PropTypes.string,
	color: PropTypes.string,
	textOnOver: PropTypes.string,
	className: PropTypes.string
};
WindowOptionButton.defaultProps = {
	onClick: () => {}
};
export default WindowOptionButton;
